import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { useService } from 'shared/providers';
import { Category } from 'shared/types';

export function useUpdateCategory() {
    const { parameterService } = useService();
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();

    const mutation = useMutation<Category, Error, Category>(request => parameterService.updateCategory(request), {
        onSuccess: data => {
            enqueueSnackbar(`Parameters for ${data.name} updated successfully!`, { variant: 'success' });
            queryClient.invalidateQueries(['category', data.key]);
        },
    });
    return mutation;
}
